import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { Typography } from "@/components/shared/typography";
import { Button, Dialog, DialogFooter, View, Image } from "@/components/ui";
import SadFace from "@/assets/images/sad-face-icon.png";
import { useVisitDetailStore } from "@/store/visits/visitDetail";

export function VisitSurveySuccessModal() {
  const { closeSkipVisitSurveySuccessModal } = useVisitDetailStore();
  return (
    <BottomDrawerModal open>
      <Dialog>
        <View className="my-2 flex flex-1 flex-col items-center">
          <Image width={120} height={120} src={SadFace} />
          <Typography variant="label-lg" color="brand-primary">
            We'll miss you this time!
          </Typography>
          <Typography variant="body-lg" className="mt-4" align="center">
            Thank you for your input. We're committed to providing you with the
            best services and will continue to improve our offerings
          </Typography>
        </View>
      </Dialog>
      <DialogFooter>
        <View className="flex flex-1 flex-col gap-2">
          <Button
            variant="primary"
            color="CTA"
            fullWidth="full"
            onClick={closeSkipVisitSurveySuccessModal}
            children="Ok"
          />
        </View>
      </DialogFooter>
    </BottomDrawerModal>
  );
}
